// utils/calculateInvoiceSummary.js

export function calculateInvoiceSummary(invoice) {
  if (!invoice?.lineItems?.length) return { subtotal: 0, discount: 0 };

  let subtotal = 0;
  let discount = 0;

  for (const item of invoice.lineItems) {
    const total = Number(item.total || 0);
    if (total < 0) {
      discount += Math.abs(total);
    } else {
      subtotal += total;
    }
  }

  return { subtotal, discount };
}
